import { useEffect } from "react";
import { app, authentication } from "@microsoft/teams-js";
import { useTranslation } from "react-i18next";
import { Loader } from "@/components";
import CONSTANTS from "@/core/utils/constants";
import { setLocalStorage } from "@/core/utils/helpers";

const AuthEnd = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get("access_token");
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    app
      .initialize()
      .then(() => {
        if (error) {
          authentication.notifyFailure(errorDescription || error);
          window.location.href = "/";
          return;
        }
        if (accessToken) {
          setLocalStorage(CONSTANTS.MICROSOFT_GRAPH_TOKEN, accessToken);
          authentication.notifySuccess(accessToken);
        } else {
          authentication.notifyFailure("No access token received");
        }
        window.location.href = "/";
      })
      .catch(() => {
        try {
          if (accessToken) {
            setLocalStorage(CONSTANTS.MICROSOFT_GRAPH_TOKEN, accessToken);
            authentication.notifySuccess(accessToken);
          } else {
            authentication.notifyFailure(
              errorDescription || error || "Authentication failed",
            );
          }
        } catch {
          window.location.href = "/";
        }
      });
  }, []);

  return <Loader label={t("Authenticating...")} />;
};

export default AuthEnd;
